import axios from "../axios";

const cancelPayment = (id) => {
    const promise = new Promise((resolve, reject) => {
        const url = `user/membergroup/cancelpayment/${id}`;
        axios
            .delete(url)
            .then((res) => resolve(res.data))
            .catch((res) => {
                reject(res);
            });
    });

    return promise;
};


export default {
    cancelPayment,
};
